import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';

// Exported label styling usable in other components
export const labelStyle = css`
    display: block;
    width: max-content;
    max-width: 100%;
    font-size: ${(props) => props.theme.font.size.small};
    font-weight: var(--font-weight-medium);
`;

export const Wrapper = styled.div.withConfig({ componentId: 'sc-16trilv-0' })`
    margin-bottom: ${size(0.5)};
`;

export const Header = styled.div.withConfig({ componentId: 'sc-16trilv-1' })`
    display: flex;
    justify-content: space-between;
`;

export const Label = styled.label.withConfig({ componentId: 'sc-16trilv-2' })`
    ${labelStyle};
`;

export const HelpBtn = styled(ButtonReset).withConfig({ componentId: 'sc-16trilv-3' })`
    position: relative;
    flex-shrink: 0;
    margin-left: ${size(2)};
    color: var(--c-link);
    font-size: ${(props) => props.theme.font.size.regular};

    // Hitbox
    &::before {
        content: "";
        position: absolute;
        inset: ${size(-1)};
    }
`;

// Ghost element to use when a spacer with the same size as label is required
export const LabelGhost = styled.div.attrs(() => ({
  'aria-hidden': 'true',
})).withConfig({ componentId: 'sc-16trilv-4' })`
    --_line-height: 1.5;
    --_margin-bottom: ${size(0.5)};

    height: calc((var(--font-size-small) * var(--_line-height)) + var(--_margin-bottom));
`;
